module.exports = __webpack_public_path__ + "img/photo_260790952_1.08a98154.png";